import { get } from 'lodash';
import { useState } from 'react';
import { setFilters, useAppDispatch } from '../../../store';

export const useTopicFilter = ({ availableTopics }: any) => {
  const [topic, setTopic] = useState(0);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const handleChangeTopic = (event: any, index: number) => {
    setLoading(true);

    const topic = availableTopics?.[index - 1]?.key;

    setTimeout(() => {
      setTopic(index);
      setLoading(false);
      dispatch(setFilters({ topic }));
    }, 500);
  };

  const filterByTopic = (events: Array<any>, eventTopicPath = 'topics') => {
    if (topic === 0) {
      return events;
    }

    const selectedTopic = availableTopics[topic - 1];

    const eventsFilteredByTopic = events.filter((item) =>
      (get(item, eventTopicPath) as string[])?.includes(selectedTopic.key),
    );

    return eventsFilteredByTopic;
  };

  return { handleChangeTopic, topic, loading, filterByTopic };
};

export default useTopicFilter;
